import React from "react";
import {
  styled,
  Stack,
  Divider,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  SxProps,
  Chip,
  Box,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface FilterAccordionProps {
  sx?: SxProps;
  children?: React.ReactNode;
  title: string | React.ReactNode;
  expanded: boolean;
  nbActiveFilters: number;
  noDivider?: boolean;
  onExpand: () => void;
}

const FilterAccordion: React.FC<FilterAccordionProps> = (props) => {
  const { onExpand, expanded, title, nbActiveFilters, children, noDivider, ...otherProps } = props;

  return (
    <FiltersPanelAccordion expanded={expanded} onChange={onExpand} {...otherProps}>
      <FiltersPanelAccordionSummary expandIcon={<AccordionExpandIcon />}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%" }}>
          <Typography variant="body1">{title}</Typography>
        </Stack>
        <Chip
          size="small"
          color={nbActiveFilters > 0 ? "info" : "default"}
          label={nbActiveFilters}
          sx={{ mr: 1, borderRadius: "10px" }}
        />
      </FiltersPanelAccordionSummary>
      <FiltersPanelAccordionDetails>
        {children}
        {(noDivider === undefined || noDivider === false) && <Divider sx={{ mt: 3 }} />}
        {noDivider && <Box sx={{ mt: 3 }}></Box>}
      </FiltersPanelAccordionDetails>
    </FiltersPanelAccordion>
  );
};

export default FilterAccordion;

const FiltersPanelAccordion = styled(Accordion)(({ theme }) => ({
  background: "transparent",
  marginBottom: theme.spacing(1.5),
  padding: 0,
  "&.Mui-expanded": {
    margin: 0,
    marginBottom: theme.spacing(1.5),
  },
}));

const AccordionExpandIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.palette.text.tier,
  transform: "rotate(-90deg)",
}));

const FiltersPanelAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  minHeight: 44,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  "&:hover": {
    background: theme.palette.background.alphaHover,
  },
  ".MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg) !important",
  },
  "&.Mui-expanded": {
    minHeight: 44,
  },
}));

const FiltersPanelAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  borderTop: "none !important",
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: 0,
}));
